import axios from 'axios'
import env from '../env'
import qs from 'qs'

const { BRANDID } = Config
/** 礼品卡相关API */
export default class GcApi {
  /** 获取礼品卡列表 */
  static async getCardList () {
    const s = {
      brandId: BRANDID,
    }
    const Url: string = `${env.MEMBER}/giftcard`
    const res: any = await axios.get(Url, {
      params: {
        s: JSON.stringify(s),
        join: ['stores'],
      },
      paramsSerializer: params => {
        return qs.stringify(params, { indices: false })
      },
      headers: {
        'token': localStorage.getItem(`ls.token${window.appEnv}.${BRANDID}`) || '',
      },
    })
    return res.error ? res : res.result
  }

  static async getCardDetail (cardId: number) {
    const Url: string = `${env.MEMBER}/giftcard/${cardId}`
    const res: any = await axios.get(Url, {
      params: {
        join: 'stores',
      }
    })
    return res.error ? res : res.result
  }

  static async getCardDecoration () {
    const Url: string = `${env.JPOSSERVICE}/jmobile/mobileTemplate/getGiftCardTemplate`
    const res: any = await axios.post(Url)
    return res.error ? res : res.result
  }
  // 获取转赠未绑定礼品卡标记
  static async getGiveFlag (memberId?: number) {
    const res: any = await axios.post(`${env.MEMBER}/memberCard/hasUnbindGiveLog`, {
      brandId: BRANDID,
      memberId
    })
    return !!res?.result?.hasUnbindGiveLog
  }
}
